import React, { useEffect, useState } from 'react';

const TICK_MS = 200;

export function formatRecordingDuration(ms) {
  const totalSeconds = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  if (hours > 0) return `${hours}:${mm}:${ss}`;
  return `${mm}:${ss}`;
}

function TrialRecordingTimer({ startedAt, endedAt }) {
  const running = typeof startedAt === 'number' && endedAt == null;
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(() => setTick((n) => n + 1), TICK_MS);
    return () => clearInterval(id);
  }, [running]);

  let elapsed = 0;
  if (typeof startedAt === 'number') {
    const end = typeof endedAt === 'number' ? endedAt : Date.now();
    elapsed = Math.max(0, end - startedAt);
  }

  return (
    <span
      className={'recording-panel__timer' + (running ? ' recording-panel__timer--live' : '')}
      role="timer"
      aria-label="Recording time"
    >
      {running ? <span className="recording-panel__timer-dot" aria-hidden="true" /> : null}
      {formatRecordingDuration(elapsed)}
    </span>
  );
}

export default TrialRecordingTimer;
